import Title from "../../../Universal/Title.component";
import { Formik } from "formik";
import DropDownInput from "../../../Universal/DropDownInput.component";
import FormInput from "../../../Universal/FormInput.component";
import FileInput from "../../Organizational/Management/Members/FileInput.component";
import DatePicker from "../../../Universal/DatePicker.component";

const BasicInfo = ({ data }) => {
  return (
    <div className="flex-col align-start justify-start g-1 w-full h-full">
      <Title className="color-textGray">
        This is institution basic, here you can add basic details.
      </Title>
      <div className="flex-row align-start justify-start g-2 back-white radius-10 flex-1 p-3 w-full">
        <Formik
          initialValues={{
            multipleBoard: false,
            instituteName: "",
            institutePhone: "",
            instituteEmail: "",
            instituteType: "",
            // joiningDate: "",
            estd: "",
            residentialType: "",
            boardType: "",
            capacity: "",
            affiliatedBy: "",
            classes: [],

            registrationNo: "",
            panNo: "",
            address: "",
            aadhaarNumber: "",

            instituteLogo: null,
          }}
          // validationSchema={MemberFormValidation} // Validation schema
          onSubmit={(values) => {
            console.log("Form Submitted:", values); // Log the values
            // setSubmittedValues(values); // Store the submitted values in state
          }}
          
        >
          {({
            setFieldValue,
            handleSubmit,
            touched,
            errors,
            setTouched,
            values,
          }) => {

            return (
              <form onSubmit={handleSubmit} className="memberForm w-full">
                <div className="flex-col align-start justify-start g-3">
                  <Title>Basic</Title>
                  <div className="flex-col align-start justify-start g-1">
                    {/* Additional fields or instructions can go here */}
                    <FileInput
                      name="instituteLogo"
                      placeholder="Upload image"
                      touched={touched}
                      label="Institute logo"
                      setFieldValue={(file) =>
                        setFieldValue("instituteLogo", file)
                      }
                    />
                    {data?.id && (
                      <span className="poppins t-14 color-grayColor">
                        ID: {data?.id}
                      </span>
                    )}
                  </div>
                </div>

                <div className="flex-col align-start justify-start g-3 flex-1">
                  {/* Gender Inputs  */}
                  <div className="genderInputs">
                    <div className="flex-row align-center justify-start g-05 toggleBtn">
                      <span>Multiple board</span>
                      <input
                        type="checkbox"
                        name="multipleBoard"
                        checked={values.multipleBoard}
                        onChange={(e) =>
                          setFieldValue("multipleBoard", e.target.checked)
                        }
                      />
                    </div>
                  </div>
                  <div className="memberAddFormTextInputs w-full">
                    <FormInput
                      type="text"
                      name="instituteName"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter your full name"
                      label="Institute Name"
                      setFieldValue={(e) =>
                        setFieldValue("instituteName", e.target.value)
                      }
                    />
                    <FormInput
                      label="Institute phone"
                      type="number"
                      name="institutePhone"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter institute phone number"
                      setFieldValue={(e) =>
                        setFieldValue("institutePhone", e.target.value)
                      }
                    />

                    <FormInput
                      label="Email"
                      type="email"
                      name="instituteEmail"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter your email address"
                      setFieldValue={(e) =>
                        setFieldValue("instituteEmail", e.target.value)
                      }
                    />
                    <DropDownInput
                      name="instituteType"
                      label="Institute Type"
                      setFieldValue={(val) =>
                        setFieldValue("instituteType", val)
                      }
                      placeholder={"Choose institute type"}
                      suggestionList={["type 1", "type 2"]}
                      errors={errors}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                      touched={touched}
                    />

                    <DatePicker
                      label="Establishment Date(ESTD.)"
                      name="estd"
                      setFieldValue={(val) => setFieldValue("estd", val)}
                      placeholder={"Choose establishment Date"}
                      errors={errors}
                    />
                    <DropDownInput
                      name="residentialType"
                      label="Residential Type"
                      setFieldValue={(val) =>
                        setFieldValue("residentialType", val)
                      }
                      placeholder={"Choose residential type"}
                      suggestionList={["Type 1", "Type 2"]}
                      errors={errors}
                      touched={touched}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                    />
                    <DropDownInput
                      name="boardType"
                      label="Board type"
                      setFieldValue={(val) => setFieldValue("boardType", val)}
                      placeholder={"Choose board type"}
                      suggestionList={["WBBSE", "WBBME", "CBSC"]}
                      errors={errors}
                      touched={touched}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                    />
                    <FormInput
                      label="Capacity"
                      type="number"
                      name="capacity"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter student capacity"
                      setFieldValue={(e) =>
                        setFieldValue("capacity", e.target.value)
                      }
                    />
                    <DropDownInput
                      name="affiliatedBy"
                      label="Affiliated by"
                      setFieldValue={(val) =>
                        setFieldValue("affiliatedBy", val)
                      }
                      placeholder={"Choose affiliated org."}
                      suggestionList={["AF1", "AF2"]}
                      errors={errors}
                      touched={touched}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                    />
                    <DropDownInput
                      name="classes"
                      label="Input classes"
                      setFieldValue={(val) => setFieldValue("classes", val)}
                      placeholder={"Choose multiple classes"}
                      suggestionList={["I", "II", "III", "IV"]}
                      errors={errors}
                      touched={touched}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                      multiple
                    />

                    <FormInput
                      type="number"
                      touched={touched}
                      errors={errors}
                      name="registrationNo"
                      label="Registration number"
                      setFieldValue={(val) =>
                        setFieldValue("registrationNo", val)
                      }
                      placeholder={"Enter institute registration number"}
                    />

                    <FormInput
                      type="text"
                      touched={touched}
                      errors={errors}
                      name="panNo"
                      label="Pan number"
                      setFieldValue={(val) => setFieldValue("panNo", val)}
                      placeholder={"Enter pan number"}
                    />
                    <FormInput
                      type="text"
                      touched={touched}
                      errors={errors}
                      name="address"
                      label="Address"
                      setFieldValue={(val) => setFieldValue("address", val)}
                      placeholder={"Enter your  address"}
                    />
                    <FormInput
                      type="number"
                      touched={touched}
                      errors={errors}
                      name="aadhaarNumber"
                      label="Aadhaar number"
                      setFieldValue={(val) =>
                        setFieldValue("aadhaarNumber", val)
                      }
                      placeholder={"Enter your  aadhaar number"}
                    />
                    <button type="submit" className="memberFormSubmitBtn">
                      Verify
                    </button>
                  </div>
                </div>
              </form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default BasicInfo;
